import {RNBridge} from "core/integration/RNBridge";
import WebUtil from "platform/util/WebUtil";

export class PostMessage {

    public static NotifyDepositSuccessful = (): void => {
        const msg: string = JSON.stringify({operation: "depositSuccessful"});
        RNBridge.send(msg);
        if (WebUtil.parentWindow()) {
            WebUtil.parentWindow().postMessage(msg, "*");
        }
    }
}
